import { css } from 'emotion';
import L from 'leaflet';

import plannedEndIconUrl from '../icons/ic_end_planned.svg';

const icon = css`
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));
`;
const placeImage = `<img src="${plannedEndIconUrl}" />`;

export const PlannedEndIcon = new L.DivIcon({
  html: `<div class="${icon}">${placeImage}</div>`,
  iconSize: [27, 33],
  iconAnchor: [13.5, 33],
});
